// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ddzI","resendInfoText":"OnGoingPaymentBox_resendInfoText__hk12c"};